const theme = {
  font: {
    primary: `'Inter', serif`,
    secondary: `'Inter', serif`,
  },
  font_size: {
    small: 'font-size: 14px; line-height: 22px',
    regular: 'font-size: 18px; line-height: 26px',
    large: 'font-size: 30px; line-height: 40px',
    larger: 'font-size: 36px; line-height: 48px',
    xlarge: 'font-size: 48px; line-height: 56px',
  },
  color: {
    white: {
      regular: '#FFFFFF',
      dark: '#F6F6F6',
    },
    black: {
      lighter: '#ABA8AF',
      light: '#564F62',
      regular: '#211E26',
    },
    primary: '#4BBABC',
    secondary: '#317d7d',
    tealLight: '#E1F4F4',
  },
  screen: {
    xs: '575px',
    sm: '767px',
    md: '991px',
    lg: '1199px',
  },
};

export default theme;
